import Header from './components/Header'
import Footer from './components/Footer'
import { Container } from 'react-bootstrap'
import {BrowserRouter as Router,Route} from 'react-router-dom'

import LoginScreen from './screens/LoginScreen'
import VideoScreen from './screens/VideoScreen'
import ProfileScreen from './screens/ProfileScreen'
import HomeScreen from './screens/HomeScreen'
function App() {
  return (
    <Router>
      <Header />
        <main className="py-3">
          <Container>
            <Route path='/' component={VideoScreen} exact />
            <Route path='/login' component={LoginScreen}  />
            <Route path='/video' component={VideoScreen}  />
            <Route path='/profile' component={ProfileScreen}  />
          </Container>
        </main>
      <Footer />
    </Router>
  );
}

export default App;
